import React from "react";
import InputForm from "../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {INSPECTION_OPTIONS} from "../utils/garrison-utils.js";

const GarrisonFixedLocationInspection = ({rows, onChangeAnswer}) => (
    <div className="grid grid-cols-2 gap-4">
        {rows.map((row, index) => {
            const selected = INSPECTION_OPTIONS.find(option => option.value === row.answer) ?? null;
            return (
                <div className="flex gap-3" key={index}>
                    <InputForm classNameWrapper="flex-[7]" id={`inspection-item-${index}`} label="Item" value={row.item ?? ""} disabled/>
                    <SelectComponent
                        classNameWrapper="flex-[4] bg-white"
                        label="Situação *"
                        required
                        options={INSPECTION_OPTIONS}
                        isDisabled={row.disabled}
                        value={selected}
                        onChange={(option) => onChangeAnswer(index, option?.value ?? "")}
                    />
                </div>
            );
        })}
    </div>
);

export default GarrisonFixedLocationInspection;